import { render } from "./InsightsButton.vue?vue&type=template&id=d78deac6&ts=true"
import script from "./InsightsButton.vue?vue&type=script&lang=ts"
export * from "./InsightsButton.vue?vue&type=script&lang=ts"

import "./InsightsButton.vue?vue&type=style&index=0&id=d78deac6&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/InsightsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d78deac6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d78deac6', __exports__)) {
    api.reload('d78deac6', __exports__)
  }
  
  module.hot.accept("./InsightsButton.vue?vue&type=template&id=d78deac6&ts=true", () => {
    api.rerender('d78deac6', render)
  })

}


export default __exports__